import { render, staticRenderFns } from "./index_GLYF_pain_point.vue?vue&type=template&id=89ff9020&scoped=true"
import script from "./index_GLYF_pain_point.vue?vue&type=script&lang=js"
export * from "./index_GLYF_pain_point.vue?vue&type=script&lang=js"
import style0 from "./index_GLYF_pain_point.vue?vue&type=style&index=0&id=89ff9020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ff9020",
  null
  
)

export default component.exports